module.exports = __webpack_public_path__ + "media/images/home/ic_duplicate-264e92cbefc44329e0f10775517a3e30.svg";